export const translation = {
    // GENERIC
    back: 'Back',
    contact: 'Contact',
    copyright: 'Copyright © {year} woom GmbH. All rights reserved.',
    country: 'Country',
    dealerLocator: 'Dealer Locator',
    deliveryDays: {
        min: '4',
        max: '7',
    },
    free: 'Free',
    international: 'International',
    language: 'Language',
    languageButton: 'Go to website',
    loading: 'Loading',
    newsletterSignup: 'Newsletter',
    next: 'Next',
    tip: 'Tip',
    cta: {
        account: {
            address: {
                create: 'Add address',
                delete: 'Delete address - {context}',
                update: 'Edit address - {context}',
            },
            bike: {
                create: 'Add bike',
                delete: 'Delete bike - {context}',
                update: 'Edit bike - {context}',
            },
            kid: {
                create: 'Add child',
                update: 'Edit child - {context}',
            },
            profile: {
                update: 'Edit profile',
            },
            cancel: 'Cancel',
            delete: 'Delete',
            login: 'Login to your Account',
            logout: 'Logout',
            openDropdown: 'Account dropdown',
            save: 'Save',
        },
        badge: {
            close: 'Close badge',
            woom_icon_badge_plus: 'Open Rider Protect Plus badge',
            woom_icon_badge_safe: 'Open KIDSAFE PLUS badge',
        },
        cart: {
            add: 'Add {product} to your @:cart.base',
            addShort: 'Add',
            buy: 'Buy now',
            closeDrawer: 'Close cart drawer',
            closePromoDrawer: 'Close {promo} drawer',
            checkout: 'Checkout',
            lineItemDecrement: 'Decrement quantity {product}',
            lineItemIncrement: 'Increment quantity {product}',
            lineItemRemove: 'Remove {product} from cart',
            openDrawer: 'Open cart drawer',
            openPromoDrawer: 'Open {promo} drawer',
            options: 'Options',
        },
        closeDialog: 'Close dialog',
        closeGalleryInfo: 'Close info',
        cookieSettings: 'Cookie-Settings',
        email: 'Enter e-mail address',
        form: {
            removeFile: 'Remove file',
        },
        learnMore: 'Learn more',
        menu: {
            back: 'Go back to previous menu',
            closeMobile: 'Close mobile menu',
            openMobile: 'Open mobile menu',
        },
        moreInfo: 'More Info',
        network: 'Visit our {network} profile',
        notifyMe: 'Notify me!',
        openLanguageDrawer: 'Open language drawer',
        playVideo: 'Play Video',
        product: {
            view: 'View {product}',
        },
        questions: 'Questions',
        readMore: 'Read more',
        skipLink: 'Skip to main content',
        slider: {
            next: 'Next slide',
            previous: 'Previous slide',
        },
        viewBundle: 'View Bundle',
        viewDetails: 'View details',
    },
    // GROUPED TRANSLATIONS (alphabetic order)
    account: {
        heading: 'Hello{nameWithSpace}!',
        add: 'Add',
        maxLimitReached: '*You have reached the maximum number of 5 {sectionTitle}.',
        easterEgg: 'Riiing! Your bike is happy to see you!',
        faq: 'Check out the %[FAQ](@:account.link.faq)% all about the woom Riders Club here.',
        address: {
            delete: {
                title: 'Are you sure you want to delete this address?',
                message: 'Once deleted, the address will no longer be visible in your account – and it will also be removed from our system.',
            },
            update: {
                title: '@:account.address.title',
            },
            default: 'This is my default address',
            defaultShort: 'Default address',
            description: 'Save time on your next purchase!',
            empty: "You haven't added an address yet. Complete your profile so that we can provide you with personalized experiences.",
            messageAddressChangeLogistics: 'For logistical reasons, we cannot update your address for any orders placed within the past 48 hours.',
            sectionTitle: 'Address',
            title: 'Your address',
        },
        benefits: ['Birthday Surprise', 'woom 10-year bike warranty', 'Exclusive early access & savings', 'Exclusive product tests'],
        bikes: {
            delete: {
                title: 'Are you sure you want to delete this bike?',
                messages: [
                    'Once deleted, the bike will no longer be visible in your account – and it will also be removed from our system.',
                    'To claim the 10-year warranty, you’ll need the written confirmation and the original purchase invoice as proof.',
                    'This action cannot be undone.',
                ],
            },
            update: {
                title: '@:account.bikes.title',
            },
            description: 'What bikes you ride and your woom 10-year warranty registration.',
            empty: 'You have not yet listed your bike/s. Register your woom bike/s so that you can activate the woom 10-year warranty.',
            messageKeepInvoice: 'Please keep hold of your receipt in case of a warranty claim.',
            messageProfileIncomplete:
                'Note: In order to successfully validate your bike registration, you must fill out all the fields in your profile.',
            off: {
                firstGen: 'first generation, model year 2021',
                secondGen: 'second generation, model year 2023',
            },
            purchaseDate: 'When you purchased it',
            purchaseDestination: 'How you purchased it',
            sectionTitle: 'Bikes',
            serialNumber: 'frame number',
            serialNumberInfo:
                "The frame number for your bike is located on the underside of the bottom bracket shell. To find the frame number, carefully turn your bike over and look for the engraved or printed number on the frame. (It'll be at the bottom in the section where the cranks are housed.)",
            serialNumberInfoHidden:
                'The bike model you have selected does not have a frame number. This model was produced without a frame number and therefore cannot be identified by one.',
            title: 'Register your bike',
            purchaseOption: {
                onlineShop: 'Online from a shop or marketplace',
                onlineUsed: 'On a website for secondhand bikes (e.g. refurbed)',
                onlineWoom: 'Through the woom online shop (woom.com)',
                private: 'From a private seller (e.g. ebay, Facebook marketplace, Gumtree)',
                store: 'In-store at a woom dealer',
            },
        },
        footer: {
            questions: {
                start: 'If you have any questions or if you would like to edit or remove your contact details, please',
                middle: 'contact us',
                end: 'directly.',
            },
        },
        kids: {
            birthdate: 'Date of birth',
            description: 'Remind us when to celebrate their birthday.',
            empty: "Not yet registered a young rider? Once we have the name and birth date of your child/children, they'll get a little gift from us each year.",
            messageDataProcessing:
                'Your data will be processed as described in the %Riders Club terms and conditions - @:account.link.termsConditions% and the %[data protection information](@:account.link.privacyPolicy)%, which I have taken note of.',
            name: '',
            sectionTitle: 'Children',
            title: 'Your child',
            tooOld: 'It looks as though you are trying to register someone that is 18 years or older.\nThe woom Riders Club is for young adventurers only.',
        },
        newsletter: {
            subscription: `YES, PLEASE. I want to receive all the latest news from woom and stay up to date with fresh product news, offers, giveaways, and the like. And just like that, {'%{'}we'll give you €5 off{'}%'} your next purchase.`,
            subscriptionDetail: `You can revoke your consent at any time with immediate effect and without having to give a reason by emailing our customer services at (%[woom{'@'}woom.com](mailto:woom{'@'}woom.com)%) or by clicking the unsubscribe link in our newsletter. If you want more information on how we process your data, we can direct you %[here](@:account.link.privacyPolicy)%.`,
            title: 'newsletter',
        },
        productTester: {
            cta: 'To the product test',
            description: "Here's where you can sign up for our next product test.",
            messageParticipation:
                'Future product testers will be picked at random. You will receive an email from us if your young rider is selected.',
            title: 'Become a product tester',
            url: '/woom-product-test',
        },
        profile: {
            description: 'Keep your information up to date and make the most of your member-only perks.',
            empty: "We don't know your name yet.",
            messageConsent:
                'In order for you to make the most of our membership perks, we will need your consent to contact you and send you marketing communications.',
            messageConsentPending:
                'Your email address has not yet been confirmed. Check your inbox again and click "confirm" in the email we sent you to validate your address.',
            messageDataProcessing: `We process your personal data as outlined in our %[privacy policy](@:account.link.privacyPolicy)%, which you have previously given your consent to.`,
            sectionTitle: 'Name',
            title: 'Your profile',
        },
        ridersClub: {
            headingNo: 'BECOME A RIDER NOW!',
            headingYes: 'Welcome to the woom Riders Club!',
            messageConsent: 'YES, I would like to join the woom Riders Club and enjoy the member-only benefits.',
            messageConsentDetail:
                'By participating, I agree to the %Riders Club T&Cs - @:account.link.termsConditions%. My data will be processed as described in the Riders Club T&Cs and the %[data protection information](@:account.link.privacyPolicy)%, which I have taken note of.',
        },
    },
    availability: {
        notifyMe: "Drop your email address here. We'll let you know as soon as this product becomes available.",
        notInThisRegion: 'This product is not available in this region',
        weeks: '{period} Weeks',
        comingsoon: 'Not in stock.\nOrder window expected to re-open in {date}',
        endOfLife: {
            status: 'Discontinued',
            description: ' – we won’t be restocking',
        },
        inStock: {
            status: 'In stock',
            description: ' – delivered to you within {min} to {max} working days!',
        },
        lowStock: {
            status: 'Almost sold out',
            description: ` - don't hang around!`,
        },
        outOfStock: {
            status: 'Sold out',
            description: ' – new stock is on the way!',
        },
    },
    badges: {
        badgeDescription: 'All components that have been specifically designed with safety in mind bear the KIDSAFE PLUS seal.',
        woom_icon_badge_protect: 'All components that have been specifically designed with safety in mind bear the RIDER PROTECT PLUS seal.',
        woom_icon_badge_safe: '@:badges.badgeDescription',
        woom_icon_badge_plus: '@:badges.badgeDescription',
        woom_icon_badge_pinch_free: 'Pinch-Free Clasp',
    },
    bikeDetail: {
        age: 'Age',
        bike: 'Size',
        features: 'Top features',
        height: 'Height',
        weight: 'Weight',
        years: 'years',
    },
    bikefinder: {
        backToStart: 'Start over',
        label: 'Find the right bike',
        resultQuery: 'result',
        age: 'year old | years old',
        maxAgeWarning: {
            heading: 'That’s it!',
            message: 'woom bikes are only designed for kids up to the age of 14 (and they’re designed just right!)',
        },
        selectHeight: 'Height',
        selectInseam: 'Inseam',
        unit: {
            cm: 'Centimeter',
            in: 'Inch',
        },
        question: {
            previous: 'Previous question',
            next: 'Next question',
        },
        duration: 'Takes around 2 minutes',
    },
    bikeGeometry: {
        height: 'Height',
        label: 'Bike geometry',
        crank: {
            length: 'Crank arm length',
        },
        handlebar: {
            height: 'Cockpit/handlebar height',
            adjust: 'Handlebar adjustment',
        },
        saddle: {
            height: {
                base: 'saddle height',
                min: 'Minimum @:bikeGeometry.saddle.height.base',
                max: 'Max. @:bikeGeometry.saddle.height.base',
            },
        },
        seatTube: {
            angle: 'Seat tube angle',
        },
        standover: {
            height: 'Stand-over height',
        },
        steering: {
            angle: 'Steering angle',
        },
        topTube: {
            horizontal: 'Horizontal top tube length',
        },
        wheel: {
            size: 'Tyre/wheel size',
            base: 'Wheelbase',
        },
    },
    bikeOptions: {
        original: {
            key: 'Your bike',
            label: 'Select your bike',
            option0: 'woom ORIGINAL 1',
            option1: 'woom ORIGINAL 1 PLUS',
            option2: 'woom ORIGINAL 2',
            option3: 'woom ORIGINAL 3',
            option4: 'woom ORIGINAL 4',
            option5: 'woom ORIGINAL 5',
            option6: 'woom ORIGINAL 6',
        },
    },
    bundleSelector: {
        baseProduct: 'Without bundle',
        heading: 'Select accessory bundle',
    },
    cart: {
        base: 'cart',
        empty: 'Your @:cart.base is empty.\nFind the right bike for your child.',
        items: 'empty | 1 item | {n} items',
        isLoading: 'Your @:cart.base is loading',
        limit: 'Order limit reached',
        reviewCart: 'Review your @:cart.base',
        subtotal: 'Subtotal',
        total: 'Your total',
        yourCart: 'Your @:cart.base',
        upsert: {
            errorFull: 'Hmm. This item could not be added to your basket this time around. Want to try again or contact us for assistance?',
            errorPartial:
                'Hmm. One or more of your items could not be added to your basket this time around. Want to try again or contact us for assistance?',
            success: 'Ride on! Your item has been successfully added to your basket.',
        },
        info0: 'woom 10-year warranty',
        info1: '30-day money-back guarantee',
        info2: 'Free returns',
        info3: `Delivery within @:{'deliveryDays.min'}-@:{'deliveryDays.max'} working days`,
        info4: 'Payment on invoice',
        // additionalShippingCharges: 'Additional shipping charges may be applied at the checkout for oversized items',
        // couldNotAdd: 'Could not add product to cart.',
        // limitedQuantityAvailable: 'You have {currentQuantity} in your cart, but we only have {quantityAvailable} available at the moment.',
        // maxQuantityReached: 'Sorry, the maximum quantity available for this product is {quantity}.',
        // productUnavailable: 'Sorry, this product is unavailable at the moment.',
        // shipping: 'Shipping',
    },
    error: {
        homepage: 'Go to homepage',
        404: `Sorry, we can't find that page.
You might have used an invalid link or the page may have been removed.`,
        '5xx': `Uuuuups!
There is something wrong with our servers.
We will be back soon.`,
    },
    forms: {
        addFile: 'Add File',
        address: 'Adress',
        addressFail: "We could not find the address with the input '{input}'",
        apartment: 'Apt./house no. (optional)',
        bikeModel: 'Bike model',
        birthdate: 'Date of birth',
        changeBirthdateText: 'Oops, wrong date? Please contact our customer service team to amend a birth date.',
        city: 'Town/City',
        clearFiles: 'clear',
        color: 'Color',
        country: 'Country / Region',
        email: 'email address',
        fileToLarge: 'File is to big',
        fileExists: 'File was already attached',
        firstName: 'First name',
        formChanged: 'At least one question has changed.\nPlease check your entries again.',
        frameNumber: 'Frame number',
        invalidValues: 'There was an error validating your input.\nPlease check your entries again.',
        lastName: 'Surname',
        Mr: 'Mr',
        Mrs: 'Mrs',
        name: 'name',
        noEditEmail: "Once you've created a profile using a certain email address, the address can no longer be changed.",
        noFiles: 'No files selected',
        purchaseDate: 'When you purchased it',
        Others: 'Prefer not to say',
        phoneNumber: 'Tel. number',
        state: 'State/county',
        selectBike: 'Select bike',
        submit: 'submit',
        submitError: 'There was an error submitting your request.\nPlease try again later.',
        typeOfPurchase: 'How you purchased it',
        xOfYFiles: '{x} of up to {y} files',
        zipCode: 'Zip/post code',
        validation: {
            required: 'This field is required.',
            email: 'A valid e-mail address is required.',
            select: 'Please make a selection.',
            phoneNumber: 'Please enter a valid phone number.',
            // right: 'The following fields contain errors: {fields}',
            // age: 'Please provide us with a valid age.',
            // number: 'A number is required in this field.',
            // file: 'Please select a file for upload.',
            // consent: 'We would need your consent to proceed.',
        },
    },
    giftcard: {
        style: 'Style',
        forMe: 'Send to me',
        forOther: 'Send as a gift',
        sendNow: 'Send now',
        sendNowText: 'The gift card will be sent immediately after purchase.',
        schedule: 'Schedule',
        scheduleInfo: 'Please note: the delivery time you selected is based on your current time zone.',
        forMeText: 'You will receive an e-mail with your gift card after purchase.',
        formInvalid: 'Please fill out all fields',
        labels: {
            senderName: 'Sender Name',
            recipientName: 'Recipient Name',
            recipientEmail: 'Recipient Email',
            recipientMessage: 'Message to Recipient',
            deliveryDate: 'Delivery Date',
        },
    },
    leggiekickstand: {
        label: 'LEGGIE kickstand for...',
    },
    price: {
        plusCustomFees: 'Plus customs fees where applicable*',
        plusCustomFeesLink: 'https://help.woombikes.com/article/589-are-customs-fees-charged-for-orders-placed-outside-of-the-eu',
        priceFrom: 'starting at {price}',
        tax: 'incl. VAT plus shipping',
        a11y: {
            strikeprice: 'list price',
        },
    },
    product: {
        colors: 'Colour | Colours',
        nameField: 'Name',
        successorMessage:
            'The {oldProductTitle} is no longer available in this color - but don’t worry, we’ve got something new for you: the {newProductTitle}!',
        sizes: {
            guide: 'Size Guide',
            s: 'Small',
            m: 'Medium',
            l: 'Large',
            xl: 'X-Large',
            'adult-s': 'S',
            'adult-m': 'M',
            'adult-l': 'L',
            'adult-xl': 'XL',
            5: '100/110',
            6: '110/120',
            7: '120/130',
            10: '130/140',
            11: '140/150',
            14: '150/160',
            helmet: {
                XS: 'XS (46-50 cm)',
                S: 'S (50-53 cm)',
                M: 'M (53-56 cm)',
            },
        },
        // design: 'Design',
        // fits: 'Compatible with',
        // position: 'Position',
        // edition: 'Edition',
        // language: 'Language',
        // size: 'Size',
        // estimateDeliveryDate: 'Est. delivery date',
        // quantity: 'One item in Stock | {n} items in Stock',
        // reviews: 'No reviews | One review | {n} reviews',
        // estimatedShipping: 'Estimated shipping',
        // estimatedTaxes: 'Estimated taxes',
        // estimatedTotal: 'Estimated total',
        // matchingProducts: 'Here are some products to match',
        // variant: {
        //     front: 'front',
        //     rear: 'rear',
        //     left: 'left',
        //     right: 'right',
        //     en: 'English',
        //     de: 'German',
        // },
        // specs: {
        //     label: 'Specifications',
        // },
    },
    upsell: {
        extras: 'Here are some other products that might interest you',
    },
    // ############### UNUSED ###################
    // discover_bikes: {
    //     open_bike_category: {
    //         original: 'Discover the woom ORIGINAL bikes',
    //         off_off_air: 'Discover mountain bikes',
    //         up: 'Discover e-mountain bikes',
    //         now: 'Discover the woom NOW',
    //     },
    // },
};

// when I move the type export to the `lang/en.ts` file, the build breaks
// maybe we can use the type at some point
export type BaseTranslation = typeof translation;
